import { BusinessPersonData } from '@/context/services/tpm/type';
import type { GetTpmInvoicesResponse } from 'ap-openapi';

/**
 * Utility function to create a BusinessPersonData object from a TPM response
 */
export const createBusinessPersonData = (
  data: GetTpmInvoicesResponse | null,
  disabled = false
): Omit<BusinessPersonData, 'parseValidityDate'> => {
  if (!data) {
    return {
      disabled: true,
    };
  }

  const periods =
    data?.qualified_period?.map((item) => ({
      label: item.label ?? '',
      period: item.period ?? '',
    })) ?? [];

  return {
    name: data?.name,
    companyType: `${data?.trade_name ? data.trade_name : '-- '}（${
      data?.kind
    }）`,
    address: data?.address,
    term: periods,
    disabled,
  };
};
